<template>
  <CommonQuery
    :formTitle="formTitle"
    :infoArray="infoArray"
    :isLoading="isLoading"
  >
    <template v-slot:result-content>
      <ResultContent :resultTemplates="resultTemplates" />
    </template>
  </CommonQuery>
</template>

<script>
/**
 * 1. 自测需要考虑方程豹服务入口
 * 2. 自测要考虑到切车
 * */
/**
 * app需要等比例放到尺寸。因为这个html是嵌入到消息体的。拿屏幕尺寸会非常的小，UI还原度太低。
 * 要达到的目的，嵌入到app的卡片html font-size:37px以上
 * 实现逻辑：
 * 1. 页面mounted的时候执行waitForFlexibleAndAdjust。等比例放大尺寸。记得检查scale
 * waitForFlexibleAndAdjust--> adjustRemBasedOnFlexible
 * 2. 页面mounted的时候监听 window.addEventListener('resize',this.handleResize) 
 * handleResize --> adjustRemBasedOnFlexible
 * 3. 页面卸载的时候移除监听
*/
import CommonQuery from '../pc/message/message-elements/common-query/index.vue'
import ResultContent from '../pc/message/message-elements/common-query/result-content.vue'
import { getCardDetails } from '@/api/workOrder'
import { SPECIAL_MSG_TYPE } from '@/utils/constant'
import { processProgressData } from '../pc/message/message-elements/car-purchase-progress/utils.js'
import { CAR_PURCHASE_CONFIG} from '../pc/message/message-elements/card-page/cardConfigs.js'

export default {
  components: { CommonQuery, ResultContent },
  data() {
    return {
      ...CAR_PURCHASE_CONFIG,
      isLoading: false,
      designRem: 37.5,  // 设计稿中1rem对应的像素值 (375/10)
      effectiveSign: undefined,
      resultTemplates: []
    }
  },
  computed: {
   
  },
  async mounted() {
    // 等待flexible.js完成rem计算后，再进行我们的放大处理
    this.waitForFlexibleAndAdjust()
    // 监听窗口变化
    window.addEventListener('resize', this.handleResize)

    console.log('this.data==>', this)
    
    await this.fetchDetail()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    /**
    * 等待flexible.js完成rem计算，然后进行调整
    */
    waitForFlexibleAndAdjust() {
      // flexible.js使用了requestAnimationFrame，所以我们需要等待它完成
      // 使用setTimeout确保在flexible.js之后执行
      // 这里的100ms是一个经验值。根据实际情况调整
      setTimeout(() => {
        this.adjustRemBasedOnFlexible()
      }, 100)
    },
    /**
     * 窗口resize时的处理
     */
    handleResize() {
      this.waitForFlexibleAndAdjust()
    },
    /**
     * 核心：基于flexible.js计算出的rem，进一步调整达到375设计稿效果
     * 
     * 原理：
     * - flexible.js 会根据实际容器宽度计算rem：rem = width / 10
     *   例如256px容器 → 1rem = 25.6px
     * - 我们希望视觉效果达到375px设计稿的效果
     *   375px设计稿期望1rem = 37.5px
     * - 所以需要放大: 37.5 / 25.6 ≈ 1.4648 倍
     */
    adjustRemBasedOnFlexible() {
      const docEl = document.documentElement
      const lib = window['lib'] || {}
      const flexible = lib.flexible || {}
      
      // 获取flexible.js计算出的当前rem值
      const currentRem = parseFloat(docEl.style.fontSize) || flexible.rem || 25.6
      console.log('currentRem==>', currentRem)
      // 计算需要放大的倍数
      // 目标：让最终的rem达到设计稿期望的37.5px效果
      const scale = this.designRem / currentRem
      console.log('scale ==>', scale)
      // 计算新的rem值：基于flexible.js的结果再放大
      const newRem = currentRem * scale
      
      // 设置新的rem
      docEl.style.fontSize = newRem + 'px'
      
      // 更新flexible对象中的rem值
      if (flexible) {
        flexible.rem = window.rem = newRem
      }
    },
    async fetchDetail() {
      try {
        const currentUrl = window.location.href
        if (currentUrl.includes('mobile/carPurchaseProgress')) {
          const search = window.location.search
          if (search) {
            const params = new URLSearchParams(search)
            this.effectiveSign = params.get('sign') || ''
          }
        } else {
          console.log('this.sign==>', this.sign)
        }
        this.isLoading = true
        const response = await getCardDetails({
          sign: this.effectiveSign,
          specialMsgType: SPECIAL_MSG_TYPE.CAR_PURCHASE_ORDER
        })
        console.log('response==>', response)
        
        // 使用 utils 中的方法处理数据，更新 infoArray
        if (response) {
           processProgressData(response, this)
        }
        
      } catch (error) {
        console.error('查询车主认证审核进度失败:', error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
